<template>
  <!-- <div class="login"> -->
    
    <el-col :xs="{offset: 1, span: 22}" :md="{offset: 8, span: 8}" class="login">
      <div class="panelheader">
        <div class="title">{{pageName}}</div>
      </div>

      <div class="login-wrapper">
        <loginform
          redirect="/sites">
        </loginform>
      </div>

    </el-col>
  <!-- </div> -->
</template>

<script>
import auth from '../auth/index'
import LoginForm from './LoginForm'
export default {
  name: 'login',
  data () {
    return {
      pageName: "Login"
    }
  },
  components: {
    'loginform': LoginForm
  }
}
</script>

<style>
  .login{
    /* width: 40%; */
    /* margin: auto; */
  }
  
  .login-wrapper {
    padding: 20pt;
    background: white;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?942570fc